import { num } from '../financeApi';

// 항목별 비중 가로 막대(한 계열이라 한 가지 색, 이름·금액·비율을 글자로 함께 표시).
export default function ShareBars({ rows, empty, limit = 8 }: { rows: { label: string; value: number }[]; empty: string; limit?: number }) {
  const total = rows.reduce((sum, r) => sum + r.value, 0);
  if (rows.length === 0 || total <= 0) return <p className="manage-side-empty" style={{ padding: 16 }}>{empty}</p>;

  // 항목이 많으면 상위 limit-1개 + '기타'로 묶는다.
  const sorted = [...rows].sort((a, b) => b.value - a.value);
  const shown = sorted.length > limit
    ? [...sorted.slice(0, limit - 1), { label: '그 외', value: sorted.slice(limit - 1).reduce((s, r) => s + r.value, 0) }]
    : sorted;

  return (
    <div className="fin-share">
      {shown.map((row) => {
        const rate = Math.round((row.value / total) * 1000) / 10;
        return (
          <div className="fin-share-row" key={row.label} title={`${row.label} ${num(row.value)}원 (${rate}%)`}>
            <div className="fin-share-top">
              <b>{row.label}</b>
              <span>{num(row.value)}원 · {rate}%</span>
            </div>
            <div className="fin-share-track">
              <div className="fin-share-fill" style={{ width: `${rate}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
